export function roundToNextHour(date) {
  const newDate = new Date(date);
  newDate.setHours(newDate.getHours() + 1, 0, 0, 0);
  return newDate;
}
